import React from 'react'
import { Route, DefaultRoute, NotFoundRoute } from 'react-router'

import App from './app'
import Dashboard from './pages/dashboard'
import NotFound from './pages/notFound'
import Events from './pages/events'
import GISMap from './pages/gis'

// Account pages
import MyAccount from './pages/account/myAccount'
import ManageGroup from './pages/account/manageGroup'
import ChangeCard from './pages/account/changeCard'
import PurchaseCredits from './pages/account/purchaseCredits'
import SwitchPlan from './pages/account/switchPlan'
import GroupSettings from './pages/account/groupSettings'
import GroupMembers from './pages/account/groupMembers'

// Record pages
import MyRecords from './pages/record/myRecords'
import NewRecord from './pages/record/newRecord'
import ImportRecords from './pages/record/importRecords'
import PropertyDetail from './pages/record/propertyDetail'
import PropertyGIS from './pages/record/propertyGIS'
import SaleDetail from './pages/record/saleDetail'
import LeaseDetail from './pages/record/leaseDetail'
import IncExpDetail from './pages/record/incExpDetail'
import ConstDetail from './pages/record/constDetail'

// Search pages
import TextSearch from './pages/search/textSearch'
import MapSearch from './pages/search/mapSearch'
import TextResults from './pages/search/textResults'
import MapResults from './pages/search/mapResults'

const routes = (
  <Route name="app" path="/" handler={App}>
    <Route name="dashboard" path="/dashboard" handler={Dashboard} />

    <Route name="my-account" path="/account" handler={MyAccount} />
    <Route name="change-card" path="/account/card" handler={ChangeCard} />
    <Route name="purchase-credits" path="/account/credit" handler={PurchaseCredits} />
    <Route name="switch-plan" path="/account/switch-plan" handler={SwitchPlan} />

    <Route name="manage-group" path="/account/group" handler={ManageGroup}>
      <Route name="group-members" path="/account/group/members" handler={GroupMembers} />
      <DefaultRoute name="group-settings" handler={GroupSettings} />
    </Route>

    <Route name="events" path="/events" handler={Events} />
    <Route name="my-records" path="/records" handler={MyRecords} />
    <Route name="new-record" path="/records/new" handler={NewRecord} />
    <Route name="import-records" path="/records/import" handler={ImportRecords} />
    <Route name="record" path="/records/:id" handler={PropertyDetail} />
    <Route name="record-gis" path="/records/:id/gis" handler={PropertyGIS} />

    <Route name="sale" path="/records/:id/sales/:transId" handler={SaleDetail} />
    <Route name="lease" path="/records/:id/leases/:transId" handler={LeaseDetail} />
    <Route name="incexp" path="/records/:id/incexps/:transId" handler={IncExpDetail} />
    <Route name="const" path="/records/:id/consts/:transId" handler={ConstDetail} />

    <Route name="text-search" path="/search" handler={TextSearch} />
    <Route name="map-search" path="/map-search" handler={MapSearch} />
    <Route name="results" path="/results" handler={TextResults} />
    <Route name="map-results" path="/map-results" handler={MapResults} />
    <Route name="gis" path="/gis" handler={GISMap} />

    <NotFoundRoute name="notfound" handler={NotFound} />
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./modules/shared/routes.js